import React, { useEffect, useState } from 'react'
import { CButton, CCloseButton, CForm, CFormFeedback, CFormInput, CFormLabel, CInputGroup, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CSpinner } from '@coreui/react'
import { dataPost, dataPut, dataError } from '@actions/data.service'
import { toastDanger, toastSuccess } from '@actions/toast.alert'
import { SelectMulti } from '@components/base/select'

const Form = ({ visible, setVisible, data = {}}) => {
    const [id, setId] = useState(0)
    const [name, setName] = useState('')
    const [permission, setPermission] = useState([])

    const [invalidName, setInvalidName] = useState('')
    const [invalidPermission, setInvalidPermission] = useState('')

    const [submit, setSubmit] = useState(false)
    const [permissions, setPermissions] = useState([])

    const { title, url, reloadTable, showToastAlert, dataForm, dataRow } = data


    useEffect(() => {
        if (visible) {
            setId(0)
            setName('')
            setPermission([{
                value: 1,
                label: 'dashboard',
                isFixed: true
            }])

            setInvalidName('')
            setInvalidPermission('')

            setSubmit(false)
            setPermissions(convertPermission(dataForm.dataPermission));

            if (dataRow) {
                setId(dataRow.id)
                setName(dataRow.name)
                setPermission(convertPermission(dataRow.permissions_src))
            }
        }
    }, [visible])

    const convertPermission = (data) => {
        let getRoles = [];
            data.map((vData) => {
                getRoles.push({
                    value: vData.id,
                    label: vData.name,
                    isFixed: vData.name == 'dashboard' ? true: false
                })
            })
        return getRoles;
    }

    const handleOnChange = (value, setValue, setInvalid) => {
        setValue(value)
        setInvalid('')
    }

    const validationRequire = (value, setInvalid) => {
        if (value.length < 1) {
            setInvalid('This field is required.')
            return Promise.reject("reject")
        }

        return Promise.resolve("resolve")
    }

    const catchOnSubmit = (err) => {
        dataError(err).then((res) => {
            if (res.errors) {
                Object.values(res.errors).shift()
            }

            showToastAlert(toastDanger(res.message))
            setSubmit(false)
        }).catch(() => {})
    }

    const handleOnSubmit = (event) => {
        event.preventDefault();
        if (submit) return;

        setInvalidName('')

        validationRequire(name, setInvalidName)
        .then((res) => {
            if (!submit) {
                setSubmit(true)

                if (dataRow) {
                    dataPut(url+'/'+id+'/update', { name, permission })
                    .then((res) => {
                        if (res && res.status === 200) {
                            reloadTable()
                            showToastAlert(toastSuccess("Data berhasil diperbaharui."))
                            setVisible(false)
                        }
                    })
                    .catch((err) => catchOnSubmit(err))
                } else {
                    dataPost(url+'/store', { name, permission })
                    .then((res) => {
                        if (res && res.status === 200) {
                            reloadTable()
                            showToastAlert(toastSuccess("Data berhasil disimpan."))
                            setVisible(false)
                        }
                    })
                    .catch((err) => catchOnSubmit(err))
                }
            }
        })
        .catch(error => {
            // reject
        })
    }


    return (
        <CModal backdrop="static" alignment="top" scrollable visible={visible}>
            <CModalHeader className='p-2' closeButton={false}>
                <CModalTitle>{title ?? ''}</CModalTitle>
                <CCloseButton onClick={() => setVisible(false)} className='me-0' />
            </CModalHeader>

            <CForm noValidate onSubmit={handleOnSubmit}>
                <CModalBody className='px-2 pt-2 pb-5'>
                    <CFormLabel htmlFor="name" className='mb-0'>Name</CFormLabel>
                    <CInputGroup size='sm' className="mb-3">
                        <CFormInput
                            type="text"
                            id="name"
                            placeholder='Enter name of role'
                            invalid={invalidName ? true : false}
                            value={name}
                            onChange={(e) => handleOnChange(e.target.value, setName, setInvalidName)}
                            required
                            />
                        <CFormFeedback invalid>{invalidName}</CFormFeedback>
                    </CInputGroup>

                    <CFormLabel htmlFor="permission" className='mb-0'>Permission</CFormLabel>
                    <CInputGroup size='sm' className="mb-3" style={{ display: 'inline-block' }}>
                        <SelectMulti
                            options={permissions}
                            value={permission}
                            onChange={(value) => handleOnChange(value, setPermission, setInvalidPermission)}
                            invalid={invalidPermission}
                            placeholder="Please select permission"
                            />
                        <CFormFeedback invalid>{invalidPermission}</CFormFeedback>
                    </CInputGroup>

                    <br /><br /><br />
                </CModalBody>

                <CModalFooter className='p-2 justify-content-start'>
                    <CButton color="secondary" size='sm' onClick={() => setVisible(false)}>Close</CButton>
                    <CButton color="primary" type="submit" size='sm'>
                        <div className="d-flex align-items-center">
                            <span>Save</span>
                            {submit ? <CSpinner color="light" size="sm" className='ms-1' /> : ''}
                        </div>
                    </CButton>
                </CModalFooter>
            </CForm>
        </CModal>
    )
}

export default Form
